import { CUBE, CYLINDER, LED_SCREEN, SPHERE, TORUS_KNOT } from '@/constants/object';

/**
 * Returns the Y offset needed so the bottom of an object sits at Y=0 (grid level).
 */
export function getGroundYOffset(type, data = {}) {
  switch (type) {
    case 'box':
    case 'cube':
      return (data.height || CUBE.HEIGHT) / 2;
    case 'sphere':
      return data.radius || SPHERE.RADIUS;
    case 'cylinder':
      return (data.height || CYLINDER.HEIGHT) / 2;
    case 'torusknot':
      return (data.radius || TORUS_KNOT.RADIUS) + (data.tube || TORUS_KNOT.TUBE);
    case 'plane':
      return 0;
    case 'led_screen': {
      const tileH = data.tileHeight || LED_SCREEN.TILE_HEIGHT;
      const vSize = data.verticalSize || LED_SCREEN.VERTICAL_SIZE;
      return (tileH * vSize) / 2;
    }
    case 'model':
      // Dimensions unknown until async load — initial Y=0, adjusted after load in model.js
      return 0;
    case 'projector':
      // Adjusted post-creation via ensureObjectAboveGrid in objectManager.js / newProjector.js
      return 0;
    default:
      return 0;
  }
}

/**
 * Finds a non-overlapping position for a new object by checking proximity
 * to existing modules and shifting along an axis until a free spot is found.
 */
export function getNonOverlappingPosition(desiredPosition, allModules, minDistance = 2, axis = 'x', step = 2) {
  let pos = { ...desiredPosition };

  const isOverlapping = () =>
    allModules.some((mod) => {
      if (!mod.data || !mod.data.position) return false;
      const mp = mod.data.position;
      const dx = mp.x - pos.x;
      const dz = mp.z - pos.z;
      return Math.sqrt(dx * dx + dz * dz) < minDistance;
    });

  let iterations = 0;
  while (isOverlapping() && iterations < 50) {
    pos[axis] += step;
    iterations++;
  }

  return pos;
}
